import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ChangeDetectorRef, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppInsightsService } from 'src/app/core/services/app-insights.service';
import { EngagementInsigtsService } from 'src/app/engagement-insights/engagement-insights.service';
import { SurveyDetailsService } from 'src/app/survey/survey-details/survey-details.service';
import { CustomUploaderComponent } from '../custom-uploader/custom-uploader.component';
import { RightSideDrawerService } from './right-side-drawer.service';
import { ModalService } from 'src/app/shared/modal/modal.service';

@Component({
  selector: 'right-side-drawer',
  templateUrl: './right-side-drawer.component.html',
  styleUrls: ['./right-side-drawer.component.scss']
})
export class RightSideDrawerComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() engagementNums: string[];
  @Input() projectNums: number[];
  @Input() surveyId: number;
  @Input() employeeId: number;
  @Input() clientId: number;
  drawerTitle: string;
  @Input() isSearchKPMG: boolean;
  @Output() confirmStatus: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() triggerExpenseData: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild(CustomUploaderComponent) private customUploader!: CustomUploaderComponent;
  saveflag = false;
  showSaveChangesModal = false;
  drawerWidth: any = "calc(46vw - 100px)";
  isLoading = false;
  drawerName: string = null;
  subscriptions: Subscription[] = [];
  data: any;
  isFileUpload = false;
  hideUploadSection = false;
  showEmailTips: boolean = false;
  constructor(
    public _rightSideDrawerService: RightSideDrawerService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _engagementService: EngagementInsigtsService,
    private _surveyDetailsService: SurveyDetailsService,
    private _appInsightsService: AppInsightsService,
    private _modalService: ModalService) { }
  ngOnDestroy(): void {
    this.subscriptions.forEach(element => {
      if (!element.closed) {
        element.unsubscribe();
      }
    });
  }

  ngOnInit() {
    this.subscriptions.push(this._rightSideDrawerService.drawerOpen.subscribe(result => {
      this.drawerWidth = "calc(46vw - 100px)";
      if (result) {
        if (result.name) {
          this.drawerName = result.name;
        } else {
          this.drawerName = null;
        }
        this.data = result.data;
        this.hideUploadSection = this.data && this.data.hideUploadSection ? this.data.hideUploadSection : false;
        this.isFileUpload = this.data && this.data.isFileupload ? this.data.isFileupload : false;
      } else {
        this.drawerName = null;
        this.data = null;
        this.isFileUpload = false;
        this.hideUploadSection = false;
      }
      this.drawerTitle = result.drawerTitle;
      this._appInsightsService.logEvent(this.drawerName + " shelve opened", {drawerTitle: this.drawerTitle});
    }));
    this.subscriptions.push(this._rightSideDrawerService.loaderObsevable.subscribe(result => {
      this.isLoading = result;
    }));
    this._rightSideDrawerService.emailTipsModal$.subscribe(modalStatus => {
      this.showEmailTips = modalStatus;
  });
  }

  drawerWidthHandeler(drawerwidth: number) {
    this.drawerWidth = drawerwidth;
    this._changeDetectorRef.detectChanges();
  }

  confirm(status) {
    this.showSaveChangesModal = false;
    if (status) {
      // Added for sme email drawer
      // this.confirmStatus.emit(status);
      if (this._rightSideDrawerService.drawerName === 'send email to sme') {
        this._engagementService.unAssignSmes(status);
        this._surveyDetailsService.unAssignSmesSingle(status);
      }
      this._rightSideDrawerService.closeRightSideDrawer();
    } else {
      this.showSaveChangesModal = false;
    }
  }
  ngAfterViewInit() {
    document.onclick = (args: any): void => {
      this.checkUploader();
      if (args.target.id === 'cover') {
        if (this._rightSideDrawerService.triggerClickClose) {
          // this.saveflag=true;
          this.showSaveChangesModal = true;
        } else {
          this._rightSideDrawerService.closeRightSideDrawer();
        }
      }
    };
  }
  
  checkUploader() {
    if (this.customUploader && this.customUploader.uploadFile) {
      this._rightSideDrawerService.triggerClickClose = true;
    }
  }
  setDrawerTitle(drawerTitle: string) {
    this.drawerTitle = drawerTitle;
    this._changeDetectorRef.detectChanges();
  }

  

  showEmailTipsModel(): void {
    this.showEmailTips = true;
    this._modalService.open('emailTips-modal');
  }
}
